import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'material-ui/DatePicker';

import {closeAddAvailableDateForm, updateAvailableDateField, updateAvailableDate, deleteAvailableDate} from '../../actions/availableDates'

class AddAvailableDate extends Component {

  static defaultProps = {
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
  }

  closeDialog() {
    const { dispatch } = this.props
    dispatch(closeAddAvailableDateForm())
  }

  updateAvailableDate() {
    const { dispatch } = this.props
    dispatch(updateAvailableDate(this.props.availableDate))
  }

  deleteAvailableDate() {
    const { dispatch } = this.props
    dispatch(deleteAvailableDate(this.props.availableDate))
  }

  updateAvailableDateField(name, event, date) {
    const { dispatch } = this.props
    dispatch(updateAvailableDateField(name, date))
  }

  render() {

    if (this.props.availableDate) {
      var actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.closeDialog.bind(this)}
        />,
        <FlatButton
					id="add_date"
          label={this.props.availableDate._id == null ? "Add Date" : "Update"}
          primary={true}
          onClick={this.updateAvailableDate.bind(this)}
        />,
      ];

      if (this.props.availableDate._id != null) {
        actions.push(<FlatButton
          label="Delete"
          secondary={true}
          onClick={this.deleteAvailableDate.bind(this)}
        />)
      }

      return (<Dialog
        actions={actions}
        title="Available Dates"
        modal={true}
        open={this.props.availableDate != null}>

        <DatePicker
          hintText="Start Date"
          name="startDate"
          value={this.props.availableDate.startDate ? new Date(this.props.availableDate.startDate) : null}
          onChange={this.updateAvailableDateField.bind(this, "startDate")}
        />
        <br />
        <DatePicker
          hintText="End Date"
          name="endDate"
          value={this.props.availableDate.endDate ? new Date(this.props.availableDate.endDate) : null}
          onChange={this.updateAvailableDateField.bind(this, "endDate")}
        />

      </Dialog>)
    } else {
      return (<div />)
    }
  }
}

const mapStateToProps = state => {
  return state.locationsReducer
}

export default withRouter(
  connect(mapStateToProps)(AddAvailableDate)
);



// WEBPACK FOOTER //
// ./src/components/locations/AddAvailableDate.js